import React, { useState } from 'react';
import { RadioButton } from '../../common/commonIndex';
import ColonosCopyActiveIcon from '../../assets/images/search/colonoscopy-active.svg';
import ColonosCopyIcon from '../../assets/images/search/colonoscopy.svg';
import EndosCopyActiveIcon from '../../assets/images/search/endoscopy-active.svg';
import EndosCopyIcon from '../../assets/images/search/endoscopy.svg';
import PatientFamilyActiveIcon from '../../assets/images/search/patientFamily-active.svg';
import PatientFamilyIcon from '../../assets/images/search/patientFamily.svg';
import ReferringProviderActiveIcon from '../../assets/images/search/referringProvider-active.svg';
import ReferringProviderIcon from '../../assets/images/search/referringProvider.svg';
import { useNavigate } from "react-router-dom";

function Search() {
    const navigate = useNavigate();
    const [selectedProcedure, setSelectedProcedure] = useState('');
    const [selectedRole, setSelectedRole] = useState('');

    const procedureList = [{ name: 'Colonoscopy', icon: ColonosCopyIcon, activeIcon: ColonosCopyActiveIcon }, { name: 'Endoscopy', icon: EndosCopyIcon, activeIcon: EndosCopyActiveIcon }];
    const memberList = [{ name: 'Patient/Family', icon: PatientFamilyIcon, activeIcon: PatientFamilyActiveIcon }, { name: 'Referring Provider', icon: ReferringProviderIcon, activeIcon: ReferringProviderActiveIcon }];
    
    const handleProcedureSelection = (procedure) => {
        setSelectedProcedure(procedure);
        const param = getQueryParams();
        if ((procedure && procedure !== '') && (selectedRole && selectedRole !== '')) {
            navigate('/doctor-profile'+ param ? '?'+param : '');
        }
    };
    const getQueryParams = () => {
        return new URLSearchParams(window.location.search);
    }
    
    const handleRoleSelection = (role) => {
        setSelectedRole(role);
        const param = getQueryParams();
        if(role && role !== ''){
            if (role?.includes('Patient')) {
                navigate('/search-result'+ window.location.search + '#Patient');
            }else if (role?.includes('Referring')) {
                navigate('/search-result'+ window.location.search + '#Referring');
            }
        }
        
    };

    return (
        <div className='custom-container'>
            <div className="procedure-selection-container">
                <h2 className='title'>What type of procedure would you like to schedule?</h2>
                <div className="role-options procedure-options list radio-button mb-3 mb-md-5">
                    {procedureList?.map((item, index) => {
                        return (
                            <div className={`list-item ${selectedProcedure === item.name ? 'selected' : ''}`} key={index}>
                                <RadioButton
                                    radioButton="schedule"
                                    name={item.name}
                                    id={index}
                                    formData={selectedProcedure}
                                    onRadioChange={() => handleProcedureSelection(item.name)}
                                    imgUrl={item.icon}
                                    activeIcon={item.activeIcon}
                                    value={selectedProcedure}
                                    setValue={setSelectedProcedure}
                                />
                                <div className={`radiobutton-schedule ${selectedProcedure === item.name ? 'selected' : ''}`}></div>
                            </div>
                        );
                    })}

                </div>

                <h2 className='title'>Are you a patient/family member or a referring provider?</h2>
                <div className="role-options procedure-options list radio-button">
                    {memberList?.map((item, index) => {

                        return (
                            <div className={`list-item ${selectedRole === item.name ? 'selected' : ''}`} key={index}>
                                <RadioButton
                                    radioButton="radioButton"
                                    name={item.name}
                                    id={index}
                                    formData={selectedRole}
                                    onRadioChange={() => handleRoleSelection(item.name)}
                                    imgUrl={item.icon}
                                    activeIcon={item.activeIcon}
                                    value={selectedRole}
                                    setValue={setSelectedRole}
                                />
                                <div className={`radiobutton-schedule ${selectedRole === item.name ? 'selected' : ''}`}></div>
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>

    );
}

export default Search;